import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sitekey: String,
    action: String,
    theme: { type: String, default: "light" }
  }

  static targets = ["widget"]

  connect() {
    // Wait for Turnstile API to be ready
    if (window.turnstile) {
      this.renderWidget()
    } else {
      // If API not loaded yet, wait for it
      this.waitForTurnstile()
    }
  }

  disconnect() {
    // Clean up the widget when navigating away
    if (this.widgetId !== undefined && window.turnstile) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = undefined
    }
  }

  waitForTurnstile() {
    const checkInterval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(checkInterval)
        this.renderWidget()
      }
    }, 100)

    // Safety timeout after 5 seconds
    setTimeout(() => clearInterval(checkInterval), 5000)
  }

  renderWidget() {
    try {
      this.widgetId = window.turnstile.render(this.widgetTarget, {
        sitekey: this.sitekeyValue,
        action: this.actionValue,
        theme: this.themeValue
      })
    } catch (error) {
      console.error("Turnstile render error:", error)
    }
  }
}
